import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import iconCopyClipboard from '../../images/common/copy.svg';

const Block = styled.div`
  display: flex;
  flex-direction; column;
  align-items: center;
  position: relative;
`;

const IconCopy = styled.img`
  width: 24px;
  cursor: pointer;
  position: fix;
`;

const Message = styled.div`
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 6px;
  position: absolute;
  top: 14px;
  left: -160px;
  font-size: 10px;
  padding: 4px;
`;

const copyToClipBoard = (text, cb) => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  el.parentElement.removeChild(el);
  cb(true);
};

class CopyClipboard extends Component {
  constructor(props) {
    super(props);
    // コンポーネント内で有効なステートを定義する
    this.state = {
      message: false,
      isMounted: false,
    };
  }

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    this.setState({ isMounted: false });
    this.clearTimer();
  }

  setTimer() {
    if (this.timerHandle) {
      // Exception?
      return;
    }
    // Remember the timer handle
    this.timerHandle = setTimeout(() => {
      this.setState({ message: false });
      this.timerHandle = 0;
    }, 3000);
  }

  clearTimer() {
    // Is our timer running?
    if (this.timerHandle) {
      // Yes, clear it
      clearTimeout(this.timerHandle);
      this.timerHandle = 0;
    }
  }

  render() {
    const { text } = this.props;
    const { message, isMounted } = this.state;
    return (
      <Block>
        <IconCopy
          id="copyToClipBoard"
          src={iconCopyClipboard}
          alt="copy to clipboard"
          onClick={() => {
            if (isMounted) {
              copyToClipBoard(text, result => {
                this.setState({ message: result });
                this.setTimer();
              });
            }
          }}
        />
        {message && (
          <Message>
            <FormattedMessage id="clipboard.copy.success" />
          </Message>
        )}
      </Block>
    );
  }
}

CopyClipboard.propTypes = {
  text: PropTypes.string,
};

CopyClipboard.defaultProps = {
  text: '',
};

export default CopyClipboard;
